export default __webpack_public_path__ + "static/media/web-form-es.812fb235.png";